import { BlockType, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  getArrayTypeReducerGuard
} from "../reducers"

export type FeedbackState = {
  exclude: Array<number>
}

const reducerAction = {
  exclude: actionCreatorTypeGuard<FeedbackState, Array<number>>(
    "exclude",
    "FeedbackState"
  ),
  __record: actionCreatorTypeGuard<TypeArray, FeedbackState>(
    "FeedbackState",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<FeedbackState>>(
    "create",
    "__create/FeedbackState"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof FeedbackState
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const feedbackStateAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const feedbackStateReducer = reducerTypeGuard<FeedbackState>()
  .case(...reducerAction.exclude)
  .build()
